:host {
  display: block;
}

.snl-mega-menu {
  ul.social-icons {
    @media screen and (max-width: 768px) {
      width: 210px;
      margin: 0 auto;
      padding-top: 16px;
      padding-bottom: 16px;
    }
  }

  ul.social-icons li {
    @media screen and (max-width: 768px) {
      margin-bottom: 0;
    }
  }
}


/* sawenri 3/6/2020 - 508 Updates for tab focus */
.social-icons {
  display: flex;
  list-style: none;
  padding: 0;

  li {
    font-size: 0.9em;
    line-height: 1.5em;
    display: inline-block;
    margin-right: 0.2em;
    padding: 0.5em 0;
  }

  li a {
    display: block;
    text-decoration: none;
    font-size: 15px;
    color: #e9e9e9;
    -webkit-transition: all 150ms ease-in-out;
    -o-transition: all 150ms ease-in-out;
    transition: all 150ms ease-in-out;
    border: 1px solid transparent;
    border-radius: 50%;
  }

  li a:hover {
    background: #fff;
    text-decoration: none;
  }

  /* sawenri 3/6/2020 - 508 Updates for tab focus */
  li a:focus {
    outline: #06c solid 1px;
  }

  li a.fa-facebook-f:hover:before {
    color: #3c589b !important;
    border-color: #3c589b !important;
  }

  li a.fa-twitter:hover:before {
    color: #1da1f3 !important;
    border-color: #1da1f3 !important;
  }

  li a.fa-youtube:hover:before {
    color: #e11d2c !important;
    border-color: #e11d2c !important;
  }

  li a.fa-flickr:hover:before {
    color: #fe0084 !important;
    border-color: #fe0084 !important;
  }

  li a.fa-instagram:hover:before {
    color: #a435b5 !important;
    border-color: #a435b5 !important;
  }

  li a.fa-rss:hover:before {
    color: #ff7b0a !important;
    border-color: #ff7b0a !important;
  }

  li a.fa-linkedin:hover:before {
    color: #0077b5 !important;
    border-color: #0077b5 !important;
  }

  li:first-child {
    font-size: 0.9em;
  }

  a:focus {
    color: #ccc;
    outline: #fff solid 2px;
    outline-offset: 2px;
  }
}

.social-icons--subsite-top {
  background: transparent;
  border-radius: 0 0 5px 5px;
  margin: 0;
  padding: 0;

  @media only screen and (max-width: 667px) {
    display: none;
  }

  @media only screen and (min-width: 668px) and (max-width: 1024px) {
    display: none;
  }

  @media screen and (max-width: 768px) {
    .social-icons {
      background: transparent;
      margin: 0;
      padding-bottom: 10;
      border-radius: 0 0 5px 5px;
    }
  }

  .social-icons li a {
    color: #727272;
  }

  .social-icons li a:hover {
    background: #fff;
  }

  .social-icons li:last-child {
    margin-right: 0;
  }
}

.social-icons--subsite-side {
  .social-icons {
    position: absolute;
    top: 13%;
    right: -70px;
    background: transparent;
    margin: 0;
    padding: 0.5em;
    border-radius: 5px;
  }

  .social-icons li {
    display: inherit;
    margin: 0.5em 0;
  }

  .social-icons li a {
    color: #212121;
    border: 1px solid #212121;
  }
}

.social-icons__blue {
  .social-icons {
    box-sizing: border-box;
    background: transparent;
  }

  .social-icons h2 {
    margin: 0;
  }

  ul {
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    list-style: none;
    justify-content: space-between;
    padding: 0;
    margin: 0;

    li {
      width: 48%;
      padding: 0;
      margin-bottom: 8px;

      @media screen and (max-width: 1024px) {
        width: 100%;
      }
    }
  }

  ul li a {
    box-sizing: border-box;
    display: inline-block;
    position: relative;
    background: linear-gradient(#5da8dd, #287ebb);
    color: #fff;
    text-align: left;
    text-decoration: none;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
    padding: 0.4em 0.5em 0.5em 3em;
    height: auto;
    width: 100%;
    border-radius: 4px;
    -webkit-transition: background 1000ms linear;
    -ms-transition: background 1000ms linear;
    transition: background 1000ms linear;

    &:hover {
      background: linear-gradient(#5da8dd, #287ebb);

      &:before {
        background: #fff !important;
      }

      span {
        color: #fff;
      }
    }

    span {
      margin-left: 16px;
      font-style: normal;
      font-weight: 400;
      font-family: "Open Sans", "Segoe UI", Tahoma, sans-serif;
      font-size: 1.2rem;
      line-height: 2em;
    }
  }

  ul a:before {
    box-sizing: border-box;
    position: absolute;
    left: 0.5em;
    display: flex;
    border: 1px solid #fff;
    border-radius: 50%;
    padding: 0;
    width: 34px;
    height: 34px;
    text-align: center;
    background: rgba(0, 0, 0, 0.07);
    justify-content: center;
    align-items: center;
  }
}